// @flow
import React from "react";
import classNames from "classnames";
import withStyles from "elevate-ui/withStyles";
import Typography from "elevate-ui/Typography";
import type { $TransformedBlogPost } from "flow/types";
type $Props = {
  classes: Object,
  className: string,
  post: $TransformedBlogPost,
};

const BlogOpenHouse = ({ classes, className, post }: $Props) => {
  const { openHouse } = post;
  if (!openHouse) {
    return <div />;
  }
  return (
    <div className={classNames(classes.root, className)}>
      <div className={classes.openHouseContainer}>
        <Typography type="heading5" className={classes.openHouseHeading}>
          {openHouse.type === "virtual" && "Virtual "}Open House
        </Typography>
        <div className={classes.openHouseMain}>
          <div className={classes.openHouseMainName}>
            {openHouse.startsOnFormatted} to {openHouse.endsOnFormatted}
          </div>
          {openHouse.url && (
            <div
              className={classNames(classes.openHouseDesc, classes.virtualLink)}
            >
              View Virtual Open House:{" "}
              <a href={openHouse.url} target="_blank" rel="noopener noreferrer">
                Click Here
              </a>
            </div>
          )}
          <div
            className={classes.openHouseDesc}
            dangerouslySetInnerHTML={{
              __html: openHouse && openHouse.description,
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default withStyles((theme) => ({
  "@global body": {
    backgroundColor: "#fff !important",
    a: {
      textDecoration: "none",
      "&:hover": {
        textDecoration: "none !important",
      },
    },
  },
  root: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    marginTop: theme.spacing.unit * 4,
    background: "#fff", // material-design 1dp

    [theme.breakpoints[600]]: {
      maxWidth: "584px",
    },

    [theme.breakpoints[900]]: {
      maxWidth: "700px",
    },
  },

  openHouseContainer: {
    padding: "0px 20px",
  },

  openHouseHeading: {
    paddingBottom: theme.spacing.unit,
    textAlign: "center",
  },

  openHouseMain: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexWrap: "wrap",
  },

  openHouseMainName: {
    paddingBottom: theme.spacing.unit * 1.5,
    color: theme.colors.gray["600"],
    letterSpacing: ".54px",
    fontWeight: "700",
    fontSize: "20px",
    textAlign: "center",
    paddingTop: theme.spacing.unit,
  },

  openHouseDesc: {
    width: "100%",
    color: "#121130",
    fontSize: "16px",
    lineHeight: "28px",
    letterSpacing: ".44px",
  },
  virtualLink: {
    fontWeight: 600,
    marginBottom: theme.spacing.unit,
    textAlign: "center",
  },

  [theme.breakpoints[600]]: {
    openHouseContainer: {
      borderBottom: theme.borders["default"],
      padding: "0px",
    },

    openHouseHeading: {
      borderBottom: theme.borders["default"],
      textAlign: "left",
    },
    openHouseMain: {
      padding: "40px 0 80px 0",
      justifyContent: "flex-start",
      flexWrap: "nowrap",
      display: "flex",
      flexDirection: "column",
    },
    openHouseMainName: {
      paddingTop: "0px",
      textAlign: "left",
    },
  },
}))(BlogOpenHouse);
